import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const FieldsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(2),
}));

// Spans both columns of the 2-column grid.
export const FullSpan = styled(Box)({
  gridColumn: '1 / -1',
});
